import {
  capitalizeFirstLetter,
  checkProductLength,
  getRandomEventId,
  getScreenName,
  replacePriceSymbol,
} from './helper';
import { fireFbAddToCart, getPriceParams } from './productPageUtils';
import { getWebUserType } from './getWebUserType';
import { fireEvent } from './fireEvent';

export const clickCardEvent = (card, section, isParentingPage) => {
  let section_id = section?.itemId || section?._id || null;
  let section_name = section?.heading || section?.itemType || null;
  let pos = section?.position || 0;
  let shape = card?.itemType;
  let deeplink = card?.deeplink;
  let deeplink_value =
    card?.webUrl || card?.deeplinkValue || card?.key || section.instaUrl;
  if (card?.viewType == 'PRODUCT') {
    shape = card?.viewType;
    deeplink = card?._id;
  }
  if (card?.viewType == 'CATEGORY') {
    deeplink = card?._id;
  }
  let cardName = card?.itemName || card?.nickname || card?.name;
  if (urlStopEvents()) {
    fireEvent({
      category: isParentingPage
        ? 'clicked_card_in_general_screen'
        : 'clicked_card_in_store_home',
      screen_name: getScreenName(),
      section_id: section_id,
      card_id: card?._id,
      section_name: section_name,
      card_name: cardName,
      shape: shape,
      position: pos,
      deeplink: deeplink,
      deeplink_value: deeplink_value,
      page_url: window.location.href.slice(0, 99),
    });
  }
};

export const cardServedEvent = (card, isParentingPage = false) => {
  let section_id = card?._id;
  let card_id = [];
  let section_name = card?.heading || card?.itemName;
  let shape = card?.items?.[0]?.itemType;
  let deeplink_value =
    getWebUserType() === 'B' ? card?.items?.[0]?.instaVideo : '';
  card?.items?.map((product) => {
    card_id.push(product?._id);
  });
  if (shape == 'PRODUCT' && card_id?.length > 1) {
    shape = card?.itemType;
  }
  if (urlStopEvents()) {
    fireEvent({
      category: isParentingPage
        ? 'served_section_in_general_screen'
        : 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: section_id,
      card_ids: card_id,
      section_name: section_name,
      shape: shape,
      deeplink_value: deeplink_value,
      page_url: window.location.href.slice(0, 99),
    });
  }
};

export const fireImpressionEvent = (data) => {
  fireEvent({ ...data, screen_name: getScreenName() });
};

export const cardCategoryServedEvent = (card, isParentingPage = false) => {
  let section_id = card?.itemId;
  let card_id = [];
  let section_name = card?.heading || card?.itemName;
  let shape = card?.items?.[0]?.itemType;
  card?.items?.map((product) => {
    product?.items?.map((cardItem) => {
      card_id.push(cardItem?._id);
    });
  });
  if (shape == 'PRODUCT' && card_id?.length > 1) {
    shape = card?.itemType;
  }
  if (urlStopEvents()) {
    fireEvent({
      category: isParentingPage
        ? 'served_section_in_general_screen'
        : 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: section_id,
      card_ids: card_id,
      section_name: section_name,
      shape: shape,
      page_url: window.location.href.slice(0, 99),
    });
  }
};

export const fireBackgroundClickEvent = (data) => {
  let section_id = data?.itemId;
  let section_name = data?.heading;
  let shape = data?.itemType;
  let deeplink = data?.deeplink;
  let deeplink_value = data?.deeplinkValue;
  if (urlStopEvents()) {
    fireEvent({
      category: 'clicked_section_img_in_myloshop',
      screen_name: 'STORE_HOME',
      section_id: section_id,
      section_name: section_name,
      shape: shape,
      deeplink: deeplink,
      deeplink_value: deeplink_value,
      web: true,
      android: true,
      page_url: window.location.href.slice(0, 99),
    });
  }
};
export const clickInstrumentationAddToCart = (
  category,
  cardData,
  productData,
  sectionName,
  sectionId,
) => {
  const productCopy = { ...productData };
  productCopy.price = replacePriceSymbol(productData?.price);
  productCopy.strikePrice = replacePriceSymbol(productData?.strikePrice);
  // productData.price = replacePriceSymbol(productData?.price);
  // productData.strikePrice = replacePriceSymbol(productData?.strikePrice);
  const isGoToCart = category === 'clicked_go_to_cart';
  let section_id = sectionId;
  let section_name = sectionName;
  let deeplink = isGoToCart ? 'cart_page' : cardData?.deeplink;
  let deeplink_value = cardData?.deeplinkValue;
  const { pricingParam, conversionParam } = getPriceParams(productData);
  const RandomEventId = getRandomEventId();
  const nickname = productCopy?.nickname
    ? checkProductLength(productCopy?.nickname)
    : checkProductLength(productCopy?.name);
  if (urlStopEvents()) {
    fireEvent({
      category: category,
      screen_name: 'STORE_HOME',
      section_id: section_id,
      id: productCopy?._id,
      sku_name: productCopy?.name,
      section_name: section_name,
      selling_price: productCopy?.price,
      deeplink: deeplink,
      deeplink_value: deeplink_value,
      sku_nickname: nickname,
      card_id: productCopy?._id,
      page_url: window.location.href.slice(0, 99),
      pricing_param: pricingParam,
      conversion_param: conversionParam,
      event_id: RandomEventId,
    });
    if (!isGoToCart) {
      fireFbAddToCart(productCopy, RandomEventId);
    }
  }
};

export const replaceTabWithAll = (key) => {
  if (key.includes('_tab_')) {
    return key.replace('_tab_', '_all_');
  }
  return key;
};

export const getCategoryRedirectUrl = (category) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.delete('subcategory');
  if (category?.parentKey) {
    if (replaceTabWithAll(category?.parentKey) !== category?.key) {
      urlSearchParams.set('subcategory', category?.key);
    }
    return `/category/${
      replaceTabWithAll(category?.parentKey) + '?' + urlSearchParams.toString()
    }`;
  } else if (category?.key) {
    return category?.key + '?' + urlSearchParams.toString();
  } else if (category?.fabDeeplinkValue) {
    window.location.href =
      category?.fabDeeplinkValue + '?' + urlSearchParams.toString();
  }
};

export const scrollToHandler = (id, scrollDiffrence) => {
  if (document.getElementById(id)) {
    const offSet =
      document.getElementById(id).offsetTop -
      (scrollDiffrence ? scrollDiffrence : 10);
    window.scrollTo(0, offSet);

    setTimeout(() => {
      const newOffSet =
        document.getElementById(id).offsetTop -
        (scrollDiffrence ? scrollDiffrence : 10);
      if (offSet !== newOffSet) {
        window.scrollTo(0, newOffSet);
      }
    }, 300);
  }
};

function urlStopEvents() {
  if (window.location.pathname.includes('fabfriday')) {
    return true;
  } else if (window.location.pathname.includes('home/')) {
    return false;
  } else {
    return true;
  }
}

export const fireClickedCta = (data, banner = null) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'STORE_HOME',
    category_name: '',
    cta: data.ctaText,
    section_id: banner?.itemId || data?.itemId,
    card_id: data.itemId,
    section_name: banner?.heading || data?.heading,
    card_name: data?.itemName || data?.heading,
    shape: data.itemType,
    deeplink: data.deeplink,
    deeplink_value: data.deeplinkValue,
    page_url: window.location.href.slice(0, 99),
  });
};

export const getSEOUtils = (brand) => {
  const metaTitle = `Mylo ${capitalizeFirstLetter(
    brand,
  )} | Shop Baby, Mom Care Products & Pregnancy Essentials Online | Mylofamily `;
  const metaDesc =
    'One stop shop for young parents. Mylo is an all in one online platform for young families, with a community of 10 Lakhs+, shop products for baby, mom, explore topics on parenthood, community discussions and a lot more.';
  const openGraphData = {
    title: metaTitle,
    description: metaDesc,
    type: 'website',
    url:
      brand == 'store'
        ? `https://mylofamily.com`
        : `https://mylofamily.com/${brand}`,
    images: [
      {
        url: 'https://mylofamily.com/v2/static/images/512mylo.png',
        width: 512,
        height: 512,
      },
    ],
  };
  return { metaTitle, metaDesc, openGraphData };
};

export const updateSideBarOrderCookie = (value) => {
  sessionStorage.setItem('sideBarOrder', value);
};
